module.exports = __webpack_public_path__ + "static/media/planeacion.6c69c9e5.svg";